import '@mdi/font/css/materialdesignicons.css';
import 'babel-polyfill';

import config from '@/common/config';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vuetify from 'vuetify';
import AppDate from './components/AppDate';
import FooterAddBtn from './components/footer/FooterAddBtn';
import FooterBackBtn from './components/footer/FooterBackBtn';
import ConfirmationDialog from './components/common/ConfirmationDialog';
import _ from 'lodash';
import vueDebounce from 'vue-debounce';
import VueAppInsights from 'vue-application-insights';
import CodeDiff from 'v-code-diff'
import Croppie from 'croppie/croppie';
import FeatureId from '@/enums/featureId';
import PermissionAction from '@/enums/permissionAction';

// Filters
import FormatDate from './filters/FormatDate.js';
import FormatDateTime from './filters/FormatDateTime.js';

// Mixins
import globalMixin from '@/mixins/globalMixin';
import newGuidMixin from '@/mixins/newGuidMixin';

import 'material-design-icons/iconfont/material-icons.css';
import 'vuetify/dist/vuetify.min.css';
import '@/styles/global.scss';

// Plugins
import '@plugins/vue-toastification'

import { StripePlugin } from '@vue-stripe/vue-stripe';

const stripeOptions = {
  pk: config.STRIPE_PUBLISH_KEY,
  testMode: true
};

Vue.use(StripePlugin, stripeOptions);

Vue.use(VueAppInsights, {
	id: config.APPINSIGHTS_INSTRUMENTATIONKEY,
	router
  })

Vue.use(Vuetify);
Vue.use(vueDebounce);
Vue.use(CodeDiff);

Vue.prototype._ = _;
Vue.prototype.$environment = config.ENVIRONMENT;

Vue.prototype.$croppie = Croppie;

// Global Components
Vue.component('AppDate', AppDate);
Vue.component('FooterBackBtn', FooterBackBtn);
Vue.component('FooterAddBtn', FooterAddBtn);
Vue.component('ConfirmationDialog', ConfirmationDialog);

Vue.prototype.$apiBaseUrl = config.API_URL;

// Global Filters
Vue.filter('formatDate', FormatDate);
Vue.filter('formatDateTime', FormatDateTime);

// Global Mixins
Vue.mixin(newGuidMixin);
Vue.mixin(globalMixin);

Vue.config.productionTip = false;


Vue.prototype.$FeatureId = FeatureId;
Vue.prototype.$PermissionAction = PermissionAction;

FreshworksWidget('hide', 'launcher');


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');

store.dispatch('auth/initializeMsalInstance', config.msalConfig).then(async () => {
	await store.dispatch('auth/handleRedirectPromise');
})